import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CardType } from '@bciti/types';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';
import { organisationConfigurationSelector } from 'src/app/global/store/global.selectors';
import { State } from 'src/app/store';

export interface UserCardDeleteErrorDialogData {
    targetCard: CardType;
    cardRequirements: string[];
    subscriptionRequirements: string[];
    userName: string;
}

@Component({
    selector: 'app-user-card-delete-error-dialog',
    templateUrl: './user-card-delete-error-dialog.component.html',
    styleUrls: ['./user-card-delete-error-dialog.component.scss'],
})
export class UserCardDeleteErrorDialogComponent implements OnInit, OnDestroy {
    destroy$ = new Subject();

    targetCard: string;

    constructor(
        private translate: TranslateService,
        private store: Store<State>,
        private dialogRef: MatDialogRef<UserCardDeleteErrorDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: UserCardDeleteErrorDialogData,
    ) {}

    ngOnInit(): void {
        this.store
            .select(organisationConfigurationSelector)
            .pipe(
                takeUntil(this.destroy$),
                filter((config) => !!config),
                map((config) => {
                    this.targetCard = config?.support?.cards.find((card) => card.type === this.data.targetCard)?.identity?.label?.[this.translate.currentLang] ?? this.data.targetCard;
                }),
            )
            .subscribe();
    }

    closeDialog(): void {
        this.dialogRef.close();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
